/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { GetLocalityRes } from '../model/GetLocalityRes';
import { BaseRequestConfig } from '../../../framework/BaseRequestConfig';

export class LocalityApi {
    /**
     * Base Pathの設定。デフォルトは「/」
     */
    protected basePath: string = '/';

    /**
     * コンストラクタ
     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
     * @param { string } basePath ベースパスを設定する
     */
    constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: ng.IHttpParamSerializer, basePath?: string) {
        if (basePath) {
            this.basePath = basePath;
        }
    }

    /**
     * 自治体一覧取得
     * 自治体にある図書館の情報を取得(検索)する。
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public localityGet(
                isDbl: boolean = false): ng.IHttpPromise<GetLocalityRes> {
        const path: string = this.basePath + '/locality';

        let queryParameters: {[index: string]: any} = {};

        let httpRequestParams: BaseRequestConfig = {
            method: 'GET',
            url: path,
            params: queryParameters,
            unique: isDbl,
            screenId: path
        };
        return this.$http(httpRequestParams);
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/locality/api/LocalityApi.ts
 **/